import React from 'react';
import { BoxProps } from '../Box';
import * as Styled from './styled';

export const Center: React.FC<BoxProps> = ({ children, ...props }) => {
    return <Styled.Center {...props}>{children}</Styled.Center>;
};
